/* eslint-disable no-useless-escape */
/* eslint-disable no-control-regex */
/* eslint-disable prefer-regex-literals */
const regex = new RegExp(
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
);
export const validateEmail = (value: any) => {
  return regex.test(value);
};

export const sortedPaymentMethod = (paymentData) =>
  [...paymentData].sort((item) => (item.isDefault ? -1 : 1));

export const getDomainFromEmail = (email: string): string => {
  const emailMatch = email.match(/@(.+)$/);
  return emailMatch ? emailMatch[1] : '';
};
